import React from 'react';
import {Form} from 'semantic-ui-react'

const ProgBitacoraNueva1 = ({styles, handleClickRegr, handleChange, handleSubmit, args}) => {

  // if(args.numDocum){
  //   var numDocum = document.getElementById("numDocum");
  //   if(numDocum){numDocum.value = args.numDocum}
  // }
  // if(args.descrEmpresa){
  //   var descrEmpresa = document.getElementById("descrEmpresa");
  //   if(descrEmpresa){descrEmpresa.value = args.descrEmpresa}
  // }
  // if(args.descrPlanta){
  //   var descrPlanta = document.getElementById("descrPlanta");
  //   if(descrPlanta){descrPlanta.value = args.descrPlanta}
  // }
  // if(args.descrSeccion){
  //   var descrSeccion = document.getElementById("descrSeccion");
  //   if(descrSeccion){descrSeccion.value = args.descrSeccion}
  // }
  // if(args.descrEquipo){
  //   var descrEquipo = document.getElementById("descrEquipo");
  //   if(descrEquipo){descrEquipo.value = args.descrEquipo}
  // }
  // if(args.descrComponente){
  //   var descrComponente = document.getElementById("descrComponente");
  //   if(descrComponente){descrComponente.value = args.descrComponente}
  // }
  // if(args.descrMecanismo){
  //   var descrMecanismo = document.getElementById("descrMecanismo");
  //   if(descrMecanismo){descrMecanismo.value = args.descrMecanismo}
  // }
  // if(args.ruta){
  //   var ruta = document.getElementById("rutaB");
  //   if(ruta){ruta.value = args.ruta}
  // }
  // if(args.numeroOrden){
  //   var numeroOrden = document.getElementById("numeroOrdenB");
  //   if(numeroOrden){numeroOrden.value = args.numeroOrden}
  // }
  // if(args.descrMetodo){
  //   var descrMetodo = document.getElementById("descrMetodo");
  //   if(descrMetodo){descrMetodo.value = args.descrMetodo}
  // }
  // if(args.estadoOrden){
  //   var estadoOrden = document.getElementById("estadoOrden");
  //   if(estadoOrden){estadoOrden.value = args.estadoOrden}
  // }  
  // if(args.realizado){
  //   var realizado = document.getElementById("realizadoB");
  //   if(realizado){realizado.value = args.realizado}
  // }

  return (
    <div>
      <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
        <div>

      <p></p>

      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
    </Form>
    </div>

  )
};

export default ProgBitacoraNueva1
